import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { SelectorSimpleFactory } from "app/features/selectores/logic";

type Entity = models.CargaDescargaFiltro;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

/**
* Valida un Entity
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = { };
    return validation.getErrors(rules, x);
}

const Limite = SelectorSimpleFactory([25, 50, 100, 200, 500, 1000, 2000], x => x, x => "" + x);

/**
* Componente para editar un Entity
*/
export class FiltroComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value } = this.props;
        const getField = this.getField;
        const Status = getField(selectores.StatusCargaDescarga);
        const Tipo = getField(selectores.TipoCargaDescarga);
        const Caja = getField(selectores.CajaRuta);
        const Lim = getField(Limite);

        const Date = getField(kea.DateTime);
        return (
            <div>
                {kea.autogrid(3, [
                    <Date field="FechaInicioInicio" label="Fecha de inicio (inicio)" />,
                    <Date field="FechaInicioFinal" label="Fecha de inicio (final)" />,

                    <Date field="FechaTerminoInicio" label="Fecha terminó (inicio)" />,
                    <Date field="FechaTerminoFinal" label="Fecha terminó (final)" />,

                    <Status field="Status" />,
                    <Tipo field="Tipo" />,
                    <Caja field="IdCajaRuta" label="Caja de ruta" />,
                    <Lim field="Limite" label="Límite:" />,
                ])}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargacajaruta/list/cargasdescargas/filtro.tsx